module.exports = __webpack_public_path__ + "static/media/yash_shetty.50c7ec43.jpg";